import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'group grid min-h-20 grid-cols-[3rem_minmax(0,1fr)_auto] items-center gap-4 overflow-hidden ' +
            'rounded-[0.875rem] border border-solid border-(--glass-chip-border) bg-(image:--glass-bg) px-4 py-3.5 ' +
            'shadow-(--shadow-glass-lift) [backdrop-filter:blur(0.75rem)] max-mobile:grid-cols-[3rem_minmax(0,1fr)]',
        icon:
            'flex size-12 items-center justify-center rounded-[0.75rem] bg-(--glass-chip-bg) text-(--accent-solid) ' +
            'group-hover:bg-(image:--accent-gradient) group-hover:text-(--pure-white)',
        content: 'min-w-0',
        name: 'truncate font-(family-name:--primary-font) text-sm font-semibold text-(--text-dark)',
        downloadButton: 'max-mobile:col-span-2 max-mobile:w-full'
    }
} satisfies ComponentTheme;
